import { render } from "./ProductTypePage.vue?vue&type=template&id=9cd2e018&scoped=true"
import script from "./ProductTypePage.vue?vue&type=script&lang=js"
export * from "./ProductTypePage.vue?vue&type=script&lang=js"

import "./ProductTypePage.vue?vue&type=style&index=0&id=9cd2e018&scoped=true&lang=css"

import exportComponent from "C:\\wamp\\www\\GuideParis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd2e018"]])

export default __exports__